/**
 * Reia — popup lead form + franchise OTP
 * Moved out of snippets/popup-form.liquid (was inline on every page) so it is cached between page views.
 */
var REIA_SHOP = window.reiaShopDomain || '';
        // ── OTP state & helpers ──
        var franchiseOtpPhone = '';
        var franchiseOtpTimerInterval = null;
        var franchiseOtpSendUrl   = '/apps/reia-booking/api/otp/send?shop=' + REIA_SHOP;
        var franchiseOtpVerifyUrl = '/apps/reia-booking/api/otp/verify?shop=' + REIA_SHOP;

        function openFranchiseOtpModal(phone) {
            // Move to <body> at open time to escape any ancestor stacking context
            var franchiseOtpEl = document.getElementById('franchise-otp-modal');
            if (franchiseOtpEl && franchiseOtpEl.parentNode !== document.documentElement) document.documentElement.appendChild(franchiseOtpEl);
            var digits = phone.replace('+91', '');
            document.getElementById('franchise-otp-subtitle').textContent =
                'We sent a 6-digit code to +91 ' + digits.slice(0,5) + ' ' + digits.slice(5) + ' on WhatsApp.';
            document.getElementById('franchise-otp-input').value = '';
            document.getElementById('franchise-otp-error').textContent = '';
            document.getElementById('franchise-otp-modal').classList.add('active');
            setTimeout(function() { document.getElementById('franchise-otp-input').focus(); }, 100);
            startFranchiseOtpTimer();
        }

        function closeFranchiseOtpModal() {
            document.getElementById('franchise-otp-modal').classList.remove('active');
            clearInterval(franchiseOtpTimerInterval);
        }

        function startFranchiseOtpTimer() {
            var secs = 60;
            var resendBtn = document.getElementById('franchise-otp-resend-btn');
            resendBtn.disabled = true;
            resendBtn.textContent = 'Resend in ' + secs + 's';
            clearInterval(franchiseOtpTimerInterval);
            franchiseOtpTimerInterval = setInterval(function() {
                secs--;
                resendBtn.textContent = secs > 0 ? 'Resend in ' + secs + 's' : 'Resend code';
                if (secs <= 0) { clearInterval(franchiseOtpTimerInterval); resendBtn.disabled = false; }
            }, 1000);
        }

        document.getElementById('franchise-otp-close').addEventListener('click', function() {
            closeFranchiseOtpModal();
            var btn = document.getElementById('submitBtn');
            btn.classList.remove('loading');
            btn.textContent = 'Submit';
            btn.disabled = false;
        });

        document.getElementById('franchise-otp-resend-btn').addEventListener('click', function() {
            var resendBtn = document.getElementById('franchise-otp-resend-btn');
            resendBtn.disabled = true;
            document.getElementById('franchise-otp-error').textContent = '';
            fetch(franchiseOtpSendUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ phone: franchiseOtpPhone }) })
                .then(function(r) { return r.json(); })
                .then(function(res) {
                    if (res.success) {
                        document.getElementById('franchise-otp-input').value = '';
                        document.getElementById('franchise-otp-error').textContent = '';
                        startFranchiseOtpTimer();
                    } else {
                        document.getElementById('franchise-otp-error').textContent = res.error || 'Unable to resend.';
                        resendBtn.disabled = false;
                    }
                })
                .catch(function() {
                    document.getElementById('franchise-otp-error').textContent = 'Unable to resend.';
                    resendBtn.disabled = false;
                });
        });

        document.getElementById('franchise-otp-input').addEventListener('input', function() {
            this.value = this.value.replace(/\D/g, '').slice(0, 6);
        });
        document.getElementById('franchise-otp-input').addEventListener('keydown', function(e) {
            if (e.key === 'Enter') document.getElementById('franchise-otp-verify-btn').click();
        });

        document.getElementById('franchise-otp-verify-btn').addEventListener('click', function() {
            var code = document.getElementById('franchise-otp-input').value.trim();
            if (code.length !== 6) {
                document.getElementById('franchise-otp-error').textContent = 'Please enter the 6-digit code.';
                return;
            }
            document.getElementById('franchise-otp-error').textContent = '';
            var verifyBtn = document.getElementById('franchise-otp-verify-btn');
            verifyBtn.disabled = true;
            verifyBtn.textContent = 'Verifying…';
            fetch(franchiseOtpVerifyUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ phone: franchiseOtpPhone, code: code }) })
                .then(function(r) { return r.json(); })
                .then(function(res) {
                    if (res.success) {
                        var form = document.getElementById('popupForm');
                        form.dataset.otpVerified = 'true';
                        form.dataset.otpVerifiedPhone = franchiseOtpPhone;
                        closeFranchiseOtpModal();
                        // Resume form submission
                        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                    } else {
                        document.getElementById('franchise-otp-error').textContent = res.error || 'Incorrect code. Please try again.';
                        verifyBtn.disabled = false;
                        verifyBtn.textContent = 'Verify & Submit';
                    }
                })
                .catch(function() {
                    document.getElementById('franchise-otp-error').textContent = 'Verification failed. Please try again.';
                    verifyBtn.disabled = false;
                    verifyBtn.textContent = 'Verify & Submit';
                });
        });

        // Popup Controls
        function openPopup() {
            const overlay = document.getElementById('popupOverlay');
            overlay.classList.add('active');
            document.body.style.overflow = 'hidden';
        }

        function closePopup() {
            closeFranchiseOtpModal(); // close OTP modal first if open
            const overlay = document.getElementById('popupOverlay');
            overlay.classList.remove('active');
            document.body.style.overflow = '';
            resetForm();
        }

        function closePopupOnOverlay(event) {
            if (event.target === event.currentTarget) {
                closePopup();
            }
        }

        // Form Validation
        function validateEmail(email) {
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return re.test(email);
        }

        function validatePhone(phone) {
            return phone.replace(/\D/g, '').length === 10;
        }

        function showError(fieldId, errorId) {
            const el = document.getElementById(fieldId);
            el.classList.add('error');
            // If inside a phone wrapper, mark the wrapper instead
            if (el.closest('.popup-phone-wrapper')) el.closest('.popup-phone-wrapper').classList.add('error');
            document.getElementById(errorId).style.display = 'block';
        }

        function hideError(fieldId, errorId) {
            const el = document.getElementById(fieldId);
            el.classList.remove('error');
            if (el.closest('.popup-phone-wrapper')) el.closest('.popup-phone-wrapper').classList.remove('error');
            document.getElementById(errorId).style.display = 'none';
        }

        function validateForm() {
            let isValid = true;

            // Check honeypot (if filled, it's a bot) - silently reject
            const honeypot = document.getElementById('website');
            if (honeypot && honeypot.value !== '') {
                console.log('Spam detected: honeypot filled');
                return false;
            }

            // Time-based spam detection - only for very fast submissions (under 2 seconds)
            if (window.reiaIsTooFastSubmission()) {
                console.log('Spam detected: too fast submission');
                return false;
            }

            // First Name
            const firstName = document.getElementById('firstName').value.trim();
            if (!firstName) {
                showError('firstName', 'firstNameError');
                isValid = false;
            } else {
                hideError('firstName', 'firstNameError');
            }

            // Last Name
            const lastName = document.getElementById('lastName').value.trim();
            if (!lastName) {
                showError('lastName', 'lastNameError');
                isValid = false;
            } else {
                hideError('lastName', 'lastNameError');
            }

            // Email
            const email = document.getElementById('email').value.trim();
            if (!email || !validateEmail(email)) {
                showError('email', 'emailError');
                isValid = false;
            } else {
                hideError('email', 'emailError');
            }

            // Mobile
            const mobile = document.getElementById('mobile').value.trim();
            if (!mobile || !validatePhone(mobile)) {
                showError('mobile', 'mobileError');
                isValid = false;
            } else {
                hideError('mobile', 'mobileError');
            }

            // City
            const city = document.getElementById('city').value.trim();
            if (!city) {
                showError('city', 'cityError');
                isValid = false;
            } else {
                hideError('city', 'cityError');
            }

            // State
            const state = document.getElementById('state').value.trim();
            if (!state) {
                showError('state', 'stateError');
                isValid = false;
            } else {
                hideError('state', 'stateError');
            }

            // Investment Budget
            const investmentBudget = document.getElementById('investmentBudget').value.trim();
            if (!investmentBudget) {
                showError('investmentBudget', 'investmentBudgetError');
                isValid = false;
            } else {
                hideError('investmentBudget', 'investmentBudgetError');
            }

            // Annual Turnover
            const annualTurnover = document.getElementById('annualTurnover').value.trim();
            if (!annualTurnover) {
                showError('annualTurnover', 'annualTurnoverError');
                isValid = false;
            } else {
                hideError('annualTurnover', 'annualTurnoverError');
            }

            return isValid;
        }

        // Form Submission
        async function handleSubmit(event) {
            event.preventDefault();

            if (!validateForm()) {
                return;
            }

            const submitBtn = document.getElementById('submitBtn');
            const form = document.getElementById('popupForm');

            // ── OTP gate ──
            const mobileInput = document.getElementById('mobile');
            const rawDigits = mobileInput.value.replace(/\D/g, '');
            const currentPhone = '+91' + rawDigits.slice(-10);
            const alreadyVerified = form.dataset.otpVerified === 'true'
                && form.dataset.otpVerifiedPhone === currentPhone;

            if (!alreadyVerified) {
                franchiseOtpPhone = currentPhone;
                submitBtn.classList.add('loading');
                submitBtn.textContent = 'Sending OTP…';
                submitBtn.disabled = true;
                try {
                    const res = await fetch(franchiseOtpSendUrl, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ phone: franchiseOtpPhone })
                    }).then(r => r.json());
                    if (res.success) {
                        openFranchiseOtpModal(franchiseOtpPhone);
                    } else {
                        submitBtn.classList.remove('loading');
                        submitBtn.textContent = 'Submit';
                        submitBtn.disabled = false;
                        alert(res.error || 'Unable to send OTP. Please try again.');
                    }
                } catch {
                    submitBtn.classList.remove('loading');
                    submitBtn.textContent = 'Submit';
                    submitBtn.disabled = false;
                    alert('Unable to send OTP. Please try again.');
                }
                return;
            }
            // ── end OTP gate ──

            submitBtn.classList.add('loading');
            submitBtn.textContent = 'Verifying...';
            submitBtn.disabled = true;

            // Function to submit with reCAPTCHA token
            async function submitFormData(recaptchaToken) {
                console.log('Submitting form with reCAPTCHA token:', recaptchaToken ? 'present' : 'missing');

                submitBtn.textContent = 'Processing...';

                // Collect form data
                const formData = {
                    firstName: document.getElementById('firstName').value.trim(),
                    lastName: document.getElementById('lastName').value.trim(),
                    email: document.getElementById('email').value.trim(),
                    mobile: document.getElementById('mobile').value.trim(),
                    city: document.getElementById('city').value.trim(),
                    state: document.getElementById('state').value.trim(),
                    investmentBudget: document.getElementById('investmentBudget').value.trim(),
                    annualTurnover: document.getElementById('annualTurnover').value.trim(),
                    source: 'popup_form',
                    timestamp: new Date().toISOString()
                };

                    try {
                        var sessionId = (typeof crypto !== 'undefined' && crypto.randomUUID)
                            ? crypto.randomUUID()
                            : Date.now().toString(36) + Math.random().toString(36).slice(2);

                        const submissionData = {
                            session_id: sessionId,
                            name: `${formData.firstName} ${formData.lastName}`,
                            email: formData.email,
                            phone: franchiseOtpPhone,
                            form_type: 'franchise',
                            page_url: window.location.href,
                            metadata: {
                                city: formData.city,
                                state: formData.state,
                                location: `${formData.city}, ${formData.state}`,
                                investment_budget: formData.investmentBudget,
                                annual_turnover: formData.annualTurnover,
                                source: formData.source,
                                timestamp: formData.timestamp,
                                ...(window.reiaGetClickAttribution ? window.reiaGetClickAttribution() : {})
                            }
                        };

                        const response = await fetch('/apps/reia-booking/api/leads?shop=' + REIA_SHOP, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            },
                            body: JSON.stringify(submissionData)
                        });

                        if (!response.ok) {
                            throw new Error('Submission failed');
                        }

                        // Show success message
                        document.getElementById('formContent').style.display = 'none';
                        document.getElementById('successMessage').style.display = 'block';

                        // Close popup after 3 seconds
                        setTimeout(() => {
                            closePopup();
                        }, 3000);

                    } catch (error) {
                        console.error('Error submitting form:', error);
                        alert('There was an error submitting the form. Please try again.');
                        submitBtn.classList.remove('loading');
                        submitBtn.textContent = 'Submit';
                        submitBtn.disabled = false;
                    }
            }

            // Try to execute reCAPTCHA v3, but fallback if it fails
            if (typeof grecaptcha !== 'undefined') {
                grecaptcha.ready(function() {
                    grecaptcha.execute('6LfipqIsAAAAABITdYfx8kF8DFNLLE0Scp86vjnj', {action: 'submit'})
                        .then(async function(token) {
                            console.log('reCAPTCHA token generated');
                            await submitFormData(token);
                        })
                        .catch(async function(error) {
                            console.error('reCAPTCHA error:', error);
                            // Fallback: submit without reCAPTCHA
                            await submitFormData(null);
                        });
                });
            } else {
                console.warn('reCAPTCHA not loaded, submitting without it');
                await submitFormData(null);
            }
        }

        function resetForm() {
            const form = document.getElementById('popupForm');
            form.reset();
            // Clear OTP verification state so the next open requires a fresh OTP
            delete form.dataset.otpVerified;
            delete form.dataset.otpVerifiedPhone;
            document.querySelectorAll('.form-input').forEach(input => {
                input.classList.remove('error');
            });
            document.querySelectorAll('.error-message').forEach(error => {
                error.style.display = 'none';
            });
            document.getElementById('formContent').style.display = 'block';
            document.getElementById('successMessage').style.display = 'none';
            const submitBtn = document.getElementById('submitBtn');
            submitBtn.classList.remove('loading');
            submitBtn.textContent = 'Submit';
            submitBtn.disabled = false;
        }

        // AUTOMATIC POPUP TRIGGERS

        // 1. Trigger when clicking any button/link with text "Sign Up Now"
        function attachSignUpTriggers() {
            // Get all links and buttons
            const elements = document.querySelectorAll('a, button');
            
            elements.forEach(element => {
                // Check if text content matches "Sign Up Now" (case insensitive)
                if (element.textContent.trim().toLowerCase() === 'sign up now') {
                    element.addEventListener('click', function(e) {
                        e.preventDefault();
                        openPopup();
                    });
                }
            });
        }

        // 2. Check for #sign-up hash in URL
        function checkHashAndOpenPopup() {
            if (window.location.hash === '#sign-up') {
                openPopup();
                // Remove the hash from URL without page jump
                history.replaceState(null, null, window.location.pathname + window.location.search);
            }
        }

        // 3. Listen for hash changes (when clicking links with #sign-up)
        window.addEventListener('hashchange', function() {
            checkHashAndOpenPopup();
        });

        // 4. Initialize everything when DOM is loaded
        document.addEventListener('DOMContentLoaded', function() {
            // Attach triggers to "Sign Up Now" buttons
            attachSignUpTriggers();
            
            // Check for #sign-up in URL
            checkHashAndOpenPopup();
            
            // Watch for dynamically added buttons (Shopify often loads content dynamically)
            const observer = new MutationObserver(function(mutations) {
                attachSignUpTriggers();
            });
            
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });

        // Lazy-load reCAPTCHA on first form interaction
        document.getElementById('popupOverlay').addEventListener('focusin', function() {
            if (window.loadRecaptcha) window.loadRecaptcha();
        }, { once: true });

        // Real-time validation
        document.getElementById('email').addEventListener('blur', function() {
            if (this.value && !validateEmail(this.value)) {
                showError('email', 'emailError');
            } else {
                hideError('email', 'emailError');
            }
        });

        document.getElementById('mobile').addEventListener('input', function() {
            this.value = this.value.replace(/\D/g, '').slice(0, 10);
        });
        document.getElementById('mobile').addEventListener('blur', function() {
            if (this.value && !validatePhone(this.value)) {
                showError('mobile', 'mobileError');
            } else {
                hideError('mobile', 'mobileError');
            }
        });
